import React, {Component} from 'react'
import {Input, Button} from 'reactstrap'
import {AvForm, AvInput} from 'availity-reactstrap-validation'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

import AUSelectGenerator from '../auto_updaters/ValidSelectInput'

const AUSelectContactMediums = AUSelectGenerator('contact_mediums', 'contact_medium_id description', 'contact_medium_id', ['description'])

class CommunicationMethodInput extends Component{

    constructor(props){
        super(props)
        this.form = null
    }

    contactMediumChanged = (value) => {
        const {onContactMediumChanged} = this.props
        if(onContactMediumChanged) onContactMediumChanged(value)
    }

    contactInfoChanged = (value) => {
        const {onContactInfoChanged} = this.props
        if(onContactInfoChanged) onContactInfoChanged(value)
    }

    save = () => {
        const {onSave} = this.props
        if(onSave) onSave()
        this.form.reset()
    }

    cancel = () => {
        const {onCancel} = this.props
        if(onCancel) onCancel()
    }

    render(){

        const {contact_medium_id, contact_info, saving} = this.props

        return (
            <AvForm className="d-flex flex-row pt-2 pb-2"
                ref={ref => this.form = ref}
                onValidSubmit={() => {
                    this.save()
                }}
            >
                <div className="d-flex mr-2" style={{flex: '1'}}>
                    <AUSelectContactMediums
                        required
                        name="contact_medium_id"
                        className="form-control-sm"
                        value={contact_medium_id}
                        onChange={this.contactMediumChanged}
                    />
                </div>
                <div className="d-flex mr-2" style={{flex: '1'}}>
                   <AvInput
                       required
                       name="contact_info"
                        size="sm"
                        placeholder="Enter Phone No, Email etc"
                        value={contact_info}
                        onChange={(evt) => this.contactInfoChanged(evt.target.value)}
                   />
                </div>

                <Button
                    size="sm"
                    color="secondary"
                    className="mr-1 square-btn"
                    onClick={this.cancel}
                >
                    <FontAwesomeIcon color="#fff" icon="times"/>
                </Button>

                <Button
                    size="sm"
                    color="success"
                    className="square-btn"
                    disabled={saving}
                >
                    <FontAwesomeIcon color="#fff" icon={saving ? 'spinner' : 'save'} spin={saving}/>
                </Button>
            </AvForm>
        )
    }

}

CommunicationMethodInput.propTypes = {
    contact_medium_id: PropTypes.number.isRequired,
    contact_info: PropTypes.string.isRequired,
    saving: PropTypes.bool.isRequired,
    onContactMediumChanged: PropTypes.func,
    onContactInfoChanged: PropTypes.func,
    onSave: PropTypes.func,
    onCancel: PropTypes.func
}

export default CommunicationMethodInput